export const userService = {
  get,
  set,
  remove,
  update,
}

function get () {
  const userSession = sessionStorage.getItem('user')
  const userLocal = localStorage.getItem('user')
  const userData = userSession || (userLocal || null)
  return userData ? JSON.parse(userData) : {}
}

function set (userData, remember) {
  if (remember) {
    localStorage.setItem('user', JSON.stringify(userData))
  } else {
    const userSession = sessionStorage.getItem('user')
    if (userSession) {
      sessionStorage.setItem('user', JSON.stringify(userData))
    } else {
      localStorage.setItem('user', JSON.stringify(userData))
    }
  }
}

function remove () {
  localStorage.removeItem('user')
  sessionStorage.removeItem('user')
}

function update (key, value) {
  const userData = get()
  userData[key] = value
  const remember = !!localStorage.getItem('user')
  set(userData, remember)
}